import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Loader2 } from "lucide-react";
import { fmtDate } from "./studioApi";

const show = (v) => (v == null || v === "" ? "—" : Array.isArray(v) ? v.join(" • ") : typeof v === "object" ? JSON.stringify(v) : String(v));

export default function RevisionHistory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get(`/studio/products/${id}`).then((r) => setP(r.data)).catch(() => {});
    api.get(`/studio/products/${id}/revisions`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [id]);
  return (
    <div className="pgt-fade-up space-y-4" data-testid="revision-history">
      <div className="flex items-center gap-3"><Button variant="ghost" size="icon" onClick={() => navigate(`/studio/products/${id}`)} data-testid="rev-back"><ArrowLeft className="h-5 w-5" /></Button><div><div className="text-xs uppercase tracking-[0.2em] text-[#AD8642] font-semibold">Revision history</div><h1 className="font-display text-3xl text-[#153E32]">{p?.name || "Product"}</h1></div></div>
      {!rows ? <Loader2 className="h-6 w-6 animate-spin text-[#153E32]" /> : rows.map((r) => (
        <Card key={r.id} className="p-4 border-[#AD8642]/25 bg-white" data-testid={`rev-${r.id}`}>
          <div className="flex items-center justify-between gap-2 flex-wrap"><div className="flex items-center gap-2"><Badge variant="outline" className="uppercase text-[10px]">{r.kind}</Badge><span className="text-sm text-[#153E32] font-semibold">{r.by_name}</span></div><span className="text-xs text-[#6A776F]">{fmtDate(r.at)} {new Date(r.at).toLocaleTimeString()}</span></div>
          {!!Object.keys(r.changes || {}).length && (
            <div className="mt-2 grid gap-1 text-xs">
              {Object.entries(r.changes).slice(0, 40).map(([k, v]) => <div key={k} className="grid grid-cols-[160px_1fr] gap-2"><span className="font-mono-id text-[#AD8642] truncate">{k}</span><span className="text-[#153E32]">{v && typeof v === "object" && "to" in v ? <><span className="line-through text-[#6A776F]">{show(v.from)}</span> → {show(v.to)}</> : show(v)}</span></div>)}
            </div>
          )}
        </Card>
      ))}
      {rows && !rows.length && <div className="text-sm text-[#6A776F]">No revisions recorded yet.</div>}
    </div>
  );
}
